module.exports = __webpack_public_path__ + "img/anggota-alt.9562256f.svg";